import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';

const client = createAxiosClient({ baseURL: '/api/2/contact-relationship' }, ServiceProxyMap.ANS);
export type CustomerType = 'PARTNER' | 'DIRECT';

interface ContactRelationship {
  resourceAri: string;
  principalAri: string;
  contactType: string;
}

interface CreateContactRelationshipPayload {
  customerType: CustomerType;
  contactRelationships: ContactRelationship[];
}

interface CreateContactRelationshipRequest {
  payload: CreateContactRelationshipPayload;
  transactionAccountId: string;
}

export const createContactRelationship = async (requestPayload: CreateContactRelationshipRequest) => {
  const response = await client.post('/bulk', requestPayload);
  return response.data;
};

interface DeleteContactRelationshipsRequest {
  payload: Array<ContactRelationship & { customerType: CustomerType }>;
  transactionAccountId: string;
}

export const deleteContactRelationship = async (requestPayload: DeleteContactRelationshipsRequest) => {
  const response = await client.delete('/', { data: requestPayload });
  return response.data;
};

interface PatchContactRelationshipsRequest {
  payload: Array<{ op: string; path: string; value: boolean; filter: ContactRelationship }>;
  transactionAccountId: string;
}

export const patchContactRelationship = async (requestPayload: PatchContactRelationshipsRequest) => {
  const response = await client.patch('/', requestPayload);
  return response.data;
};
